import PropTypes from 'prop-types';

import styles from './styles/CreatorsTitle.scss';

export function CreatorsTitle({ children, tagName, dataTn = '' }) {
    // must be uppercase to not be interpreted literally by jsx
    const TagName = tagName;
    const titleDataTn = `creators-title-${dataTn}`;
    return (
        <TagName className={styles.title} data-tn={titleDataTn}>
            {children}
        </TagName>
    );
}

CreatorsTitle.propTypes = {
    tagName: PropTypes.string.isRequired,
    children: PropTypes.node,
    dataTn: PropTypes.string,
};
